import React from "react";
import styled from "styled-components";
import { pompadour, green, mediumGrey, lightGrey } from "../colors";

export default ({ label, children, ...otherProps }) => (
  <RaisedButton {...otherProps}>{children || label.toUpperCase()}</RaisedButton>
);

const RaisedButton = styled.button`
  border: none;
  border-radius: 2px;
  box-shadow: ${props =>
    !props.disabled && "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px"};

  background-color: ${props =>
    (props.disabled && lightGrey) ||
    (props.primary && pompadour) ||
    (props.secondary && green) ||
    "white"};
  font-size: 14px;
  padding: 15px 18px;
  color: ${props =>
    (props.disabled && mediumGrey) || ((props.primary || props.secondary) && "white") || pompadour};

  outline: none;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/AsapRaisedButton.js